import * as yup from "yup";
import { VALIDATOR_STRING_REQUIRED } from "../../../../constants/validation/validators";

export const schema = yup.object().shape({
  login: VALIDATOR_STRING_REQUIRED,
  password: VALIDATOR_STRING_REQUIRED,
});
